import { render, staticRenderFns } from "./RoomDescriptionDialog.vue?vue&type=template&id=3c6a23ac&"
import script from "./RoomDescriptionDialog.vue?vue&type=script&lang=ts&"
export * from "./RoomDescriptionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RoomDescriptionDialog.vue?vue&type=style&index=0&id=3c6a23ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports